import React from "react";
import Grid2 from "@mui/material/Grid2"; // Import Grid2 for layout
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import i18n from "i18n/i18n";
import store from "./redux/store";
import Header from "components/Header/Header";
import Footer from "./components/Footer/Footer";
import GlobalStylesComponent from "components/GlobalStyles/GlobalStylesComponent";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import Home from "pages/main/IndexPage/IndexPage";
import ResourcePage from "pages/main/ResourcePage/ResourcePage";
import WizardPage from "pages/main/WizardPage/WizardPage";
import SolutionsPage from "pages/solutions/SolutionsPage";
import PoliciesPage from "pages/solutions/policies/PoliciesPage";
import PolicyDetailPage from "pages/solutions/policies/PolicyDetailPage";
import OperationalStrategiesPage from "pages/solutions/operational/OperationalStrategiesPage";
import OperationalStrategyDetailPage from "pages/solutions/operational/OperationalStrategyDetailPage";
import LessonsLearnedPage from "pages/solutions/lessons_learned/LessonsLearnedPage";
import LessonsLearnedDetailPage from "pages/solutions/lessons_learned/LessonsLearnedDetailPage";
import default_theme from "assets/themes/themes";
import MainLayout from "components/MainLayout/MainLayout";

const App = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <ThemeProvider theme={default_theme}>
          <GlobalStylesComponent />
          <Router>
            <MainLayout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/resources" element={<ResourcePage />} />
                  <Route path="/wizard" element={<WizardPage />} />
                  <Route path="/solutions" element={<SolutionsPage />} />
                  <Route path="/solutions/policies" element={<PoliciesPage />} />
                  <Route path="/solutions/policies/:slug/:section?" element={<PolicyDetailPage />} />
                  <Route path="/solutions/operational" element={<OperationalStrategiesPage />} />
                  <Route path="/solutions/operational/:slug/:section?" element={<OperationalStrategyDetailPage />} />
                  <Route path="/solutions/past-experiences" element={<LessonsLearnedPage />} />
                  <Route path="/solutions/past-experiences/:slug/:section?" element={<LessonsLearnedDetailPage />} />
                </Routes>
            </MainLayout>
          </Router>
        </ThemeProvider>
      </Provider>
    </I18nextProvider>
  );
};

export default App;
